import React, { useState, useEffect } from "react";
import DateItem from "./DateListItemView.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Svg from "components/Svg/Svg";

const DatesListControl = (props) => {
  const [items, setItems] = useState(props.items || []);

  useEffect(() => {
    setItems(props.items);
  }, [props.items]);

  const onNewItem = () => {
    let items = [...props.items];
    items.push({ date: null, text: "" });

    if (props.onChange) {
      props.onChange(items);
    }
  };

  const onDelete = (index) => {
    let newItems = [...props.items];
    newItems.splice(index, 1);
    setItems(newItems);

    if (props.onChange) {
      props.onChange(newItems);
    }
  };

  const onChange = (item, index) => {
    let newItems = props.items.map((pItem, pInd) => {
      if (pInd === index) {
        return item;
      }

      return pItem;
    });

    setItems(newItems);

    if (props.onChange) {
      props.onChange(newItems);
    }
  };

  return (
    <div className="flex flex-col w-full">
      {items.map((item, ind) => (
        <DateItem
          disabled={props.disabled || false}
          onDelete={() => {
            onDelete(ind);
          }}
          onChange={onChange}
          text={item.text}
          index={ind}
          textLabel={props.textLabel}
          date={item.date}
          key={ind}
        />
      ))}
      {(!items || items.length === 0) && <div className="sub-text">No dates...</div>}
      <Button
        disabled={props.disabled || false}
        bsStyle="danger"
        fill
        style={{ marginLeft: "auto" }}
        onClick={() => onNewItem()}
        type="button"
      >
        <Svg name="plus" className="w-4 h-4" />
        Add Date
      </Button>
    </div>
  );
};

export default DatesListControl;
